<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import ProductService from '@/services/product'
import SaleService from '@/services/sale'
import VueGallerySlideshow from 'vue-gallery-slideshow';
import { StreamBarcodeReader } from 'vue-barcode-reader';

export default {
  page: {
    title: "Inclusão de Pedido",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, VueGallerySlideshow, StreamBarcodeReader },
  data() {
    return {
      title: "Inclusão de Pedido",
      order: {
        cart: {
          customer: {},
          company: {},
        }
      },
      customerName: '',
      companyName: '',
      customerValueLimit: 0,
      customerValueAvailable: 0,
      customerOverdueValue: 0,
      products: [],
      emptyProducts: false,
      loadingProducts: false,
      showTaxesModal: false,
      productSelected: {
        taxes: {}
      },

      searchValue: '',
      lastSearchValue: '',
      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,

      images: [],
      imageZoomIndex: null,
    };
  },
  mounted() {
    const tempOrder = this.$store.getters.orderData;
    this.order = tempOrder;

    if (this.order && this.order.cart) {
      this.customerName = this.order.cart.customer.name;
      this.companyName = this.order.cart.company.name;
    }

    let loader = this.$loading.show();

    if (!this.order.cartId) {
      SaleService.createCart(this.order.companyId, this.order.customerId).then((res) => {
        this.order.cart = res.data;
        this.order.cartId = res.data._id;

        this.customerName = this.order.cart.customer.name;
        this.companyName = this.order.cart.company.name;
        this.customerValueLimit = this.order.cart.customer.totalCreditLimit || 0;
        this.customerValueAvailable = this.customerValueLimit - (this.order.cart.customer.consumedCreditLimit || 0);
        this.customerOverdueValue = this.order.cart.customer.overdueTotalValue;

        this.$store.dispatch('SAVE_ORDER', this.order);

        loader.hide();
      }).catch(() => {
        this.$toast.error('Erro ao carregar os dados do pedido');
        loader.hide();
      })
    } else {
      SaleService.getCart(this.order.cartId).then((res) => {
        this.order.cart = res.data;
        this.order.cartId = res.data._id;

        this.customerName = this.order.cart.customer.name;
        this.companyName = this.order.cart.company.name;
        this.customerValueLimit = this.order.cart.customer.totalCreditLimit || 0;
        this.customerValueAvailable = this.customerValueLimit - (this.order.cart.customer.consumedCreditLimit || 0);
        this.customerOverdueValue = this.order.cart.customer.overdueTotalValue;

        this.$store.dispatch('SAVE_ORDER', this.order);

        loader.hide();
      }).catch(() => {
        this.$toast.error('Erro ao carregar os dados do pedido')
        loader.hide();
      })
    }
  },
  methods: {
    loadProducts(showLoading = true, page = 1, term = '', atacarejo = false) {
      if (showLoading) {
        this.loadingProducts = true;
      }

      ProductService.getAll(page, term, this.order.cart.company.code, this.order.cart._id, atacarejo)
        .then(res => {
          this.loadingProducts = false;

          this.products = res.data.products;
          this.count = res.data.count;
          this.currentCount = res.data.currentCount;
          this.currentPage = res.data.currentPage;
          this.totalPages = res.data.totalPages;
          this.perPage = res.data.perPage;
          this.startIndex = res.data.startIndex;
          this.endIndex = res.data.endIndex;

          this.emptyProducts = res.data.products.length === 0;

          this.populateProductsWithCart(true);
        })
      .catch(() => {
        this.loadingProducts = false;
      })
    },
    onPageChange() {
      window.scrollTo(0,0);
      this.loadProducts(true, this.currentPage, this.lastSearchValue);
    },
    search() {
      this.lastSearchValue = this.searchValue;
      this.loadProducts(true, 1, this.searchValue);
    },
    searchProductsAtacarejo() {
      this.searchValue = '';
      this.loadProducts(true, 1, this.searchValue, true);
    },
    addItem(product) {
      let quantity = Number(product.cartQuantity);
      quantity += 1;

      product.cartQuantity = quantity;
    },
    removeItem(product) {
      let quantity = Number(product.cartQuantity);
      if (quantity > 0) {
        quantity -= 1;
        product.cartQuantity = quantity;
      }
    },
    addToCart(data) {
      if (!data.cartQuantity || data.cartQuantity === 0) {
        return this.$toast.warning('Informe a quantidade para adicionar no carrinho');
      }

      let quantityDiscountPrice;
      if (data.quantityDiscount) {
        quantityDiscountPrice = data.quantityDiscount.price
      }

      SaleService.addItem(this.order.cartId, {
        product: data._id,
        quantity: data.cartQuantity,
        price: data.price,
        originalPrice: data.taxes.originalPrice,
        quantityDiscountPrice,
        ipiValue: data.taxes.ipiValue,
        stValue: data.taxes.stValue,
        ipiPercentage: data.taxes.ipiPercentage,
        stPercentage: data.taxes.stPercentage,

      }).then((res) => {
        this.searchValue = '';

        this.order.cart = res.data;
        data.inCart = true;

        this.$toast.open('Item adicionado ao carrinho');

        this.populateProductsWithCart();

        this.$store.dispatch('SAVE_ORDER', this.order);
      }).catch((error) => {
        this.populateProductsWithCart();

        if (error.response.data.code && error.response.data.code === 'E9999') {
          return this.$toast.warning(error.response.data.msg, {
            duration: 10000,
          });
        }

        this.$toast.error('Não foi possível adicionar o item ao carrinho');
      })

    },
    removeFromCart(data) {
      if (!data.cartQuantity || data.cartQuantity === 0) {
        return this.$toast.warning('O produto não foi adicionado ao carrinho');
      }

      SaleService.removeItem(this.order.cartId, data._id).then((res) => {
        this.order.cart = res.data;
        data.inCart = false;
        data.cartQuantity = null;

        this.$toast.open('Item removido do carrinho');

        this.populateProductsWithCart();

        this.$store.dispatch('SAVE_ORDER', this.order);
      }).catch(() => {
        this.$toast.error('Não foi possível remover o item do carrinho');
      })
    },
    cancelOrder() {
      this.$store.dispatch('STOP_ORDER')
      this.$router.push({ name: 'dashboard' })
    },
    populateProductsWithCart() {
      this.products = this.products.map(item => {
        const findItem = this.order.cart.items.find(cartItem => cartItem.productId === item._id);
        const cartQuantity = findItem ? findItem.quantity : null;
        
        return {
          ...item,
          inCart: findItem ? true : false,
          cartQuantity,
          noStock: (cartQuantity || 0) > item.stock,
        }
      })
    },
    closeOrder() {
      this.$router.push({ name: 'cart' })
    },
    taxesInfo(data) {
      this.productSelected = data;
      this.showTaxesModal = true;
    },
    showImageGallery(data) {
      this.images = (data.imagesMobwit && data.imagesMobwit.length) ? data.imagesMobwit : [data.image];
      this.imageZoomIndex = 0;
    },
    onDecode(result) {
      this.searchValue = result;
      this.search();
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <b-card header-class="bg-transparent border-primary" class="border border-primary">
          <div class="row">
            <div class="col-lg-6">
              <p class="card-text mb-0">Cliente selecionado</p>
              <h5 class="card-title">{{customerName}}</h5>
            </div>

            <div class="col-lg-3">
              <p class="card-text mb-0">Limite / Disponível</p>
              <h5 class="card-title">R$ {{customerValueLimit | currency}} / R$ {{customerValueAvailable | currency}}</h5>
            </div>

            <div class="col-lg-3">
              <button type="button" class="btn btn-primary btn-block" @click="closeOrder">Fechar Pedido</button>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-lg-6">
              <p class="card-text mb-0">Filial selecionada</p>
              <h5 class="card-title">{{companyName}}</h5>
            </div>

            <div class="col-lg-3">
              <p class="card-text mb-0">Valor vencido</p>
              <h5 class="card-title">R$ {{customerOverdueValue | currency}}</h5>
            </div>

            <div class="col-lg-3">
              <button
                v-b-modal.modal-remove
                type="button"
                class="btn btn-outline-danger btn-block"
              >Cancelar Orçamento</button>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">          
          <div class="card-body">
            <div class="row mb-2 align-items-center">
              <div class="col-sm-12 col-md-6 col-lg-6">
                <div class="mr-2 mb-2">
                  <h4 class="card-title mb-2">PRODUTOS</h4>
                  <div class="position-relative search-input">
                    <form @submit.prevent="search" class="align-items-center">
                      <input type="text" class="form-control" v-model="searchValue" placeholder="Nome, código ou EAN..." />
                      <!-- <i class="bx bx-search-alt search-icon"></i> -->

                      <button type="submit" class="btn btn-primary" v-if="!loadingProducts">
                        Pesquisar
                      </button>

                      <button class="btn btn-outline-primary" v-if="!loadingProducts" @click="searchProductsAtacarejo()">
                        Ofertas Atacarejo
                      </button>

                      <a href="javascript:void(0);" class="text-primary" v-if="loadingProducts">
                        <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
                      </a>

                      <!-- <button
                        class="btn btn-outline-primary"
                        v-b-modal.modal-barcode
                        type="button"
                      >
                        Código Barras
                      </button> -->
                    </form>

                    <div class="custom-control custom-checkbox mt-2">
                      <input type="checkbox" class="custom-control-input" id="customCheck1"/>
                      <!-- <label class="custom-control-label font-weight-normal" for="customCheck1">Mostrar apenas produtos ATACAREJO</label> -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col-->
            </div>

            <div>
              <!-- Table data -->
              <div class="card">
                <div class="card-body">

                  <div class="empty-data text-primary p-5" v-if="emptyProducts">
                    <i class="bx bx-search-alt font-size-24 mb-2"></i>
                    <h4 class="text-primary">Produto indisponível</h4>
                  </div>

                  <div class="table table-responsive table-centered" v-if="products && products.length > 0">
                    <table class="table mb-0">
                      <tbody>
                        <tr v-for="data in products" :key="data._id" :class="{ 'in-cart' : data.inCart }">
                          <td class="product-image">
                            <img
                              :src="data.image"
                              class="avatar-md gallery-image"
                              @click="showImageGallery(data)"
                            />

                            <p class="m-0 text-muted zoom-image-info">Clique para ampliar</p>
                          </td>
                          <td>
                            <h5 class="font-size-14">
                              {{data.description}} {{data.complement}}
                            </h5>
                            <p class="mb-0 font-size-12">
                              Código: <span class="font-weight-medium">{{data.code}}</span> /
                              Embalagem: <span class="font-weight-medium">{{data.unity}}</span> /
                              Cx: <span class="font-weight-medium">{{data.packQuantity}}</span> / 
                              Cor: <span class="font-weight-medium">{{data.color}}</span> /
                              Estoque: <span class="font-weight-medium mr-2">{{data.stock}}</span>
                              <span
                                class="badge badge-pill badge-soft-success font-size-12"
                                :class=" { 'badge-soft-danger': (data.noStock || !data.available) }"
                              >{{data.noStock ? 'Estoque Insuficiente' : data.stockMessage}}</span>

                              <span class="badge badge-pill badge-soft-warning font-size-12 ml-2 font-weight-bold" v-if="data.available && data.paymentConditionInfo">
                                {{ data.paymentConditionInfo }}
                              </span>
                            </p>
                            <b-button variant="link" size="sm" @click="taxesInfo(data)">ver impostos</b-button>
                          </td>
                          <!-- <td class="text-truncate">
                            <span
                              class="badge badge-pill badge-soft-success font-size-12"
                              :class=" { 'badge-soft-danger': !data.available }"
                            >{{data.stockMessage}}</span>
                          </td> -->
                          <td class="text-truncate price-col">
                            <!-- <div v-if="data.available && !data.quantityDiscount">R$ {{data.price | currency}}</div> -->

                            <div v-if="data.available && !data.quantityDiscount" class="font-weight-bold font-size-16">R$ {{data.price | currency}}</div>

                            <div v-if="data.available && data.quantityDiscount && data.quantityDiscount.quantity > 1">
                              <div class="font-weight-bold font-size-16">R$ {{data.price | currency}}</div>
                              <p class="text-muted font-size-12 mb-0">A partir de <span class="font-weight-bold font-size-13 text-primary">{{data.quantityDiscount.quantity}}</span> unidades:</p>
                              <span class="badge badge-primary font-size-14">R$ {{data.quantityDiscount.price | currency}} <span class="font-size-11">cada</span></span>
                            </div>

                            <div v-if="data.available && data.quantityDiscount && data.quantityDiscount.quantity === 1">
                              <p class="font-weight-bold font-size-16 mb-1"><span class="font-weight-bold font-size-13 text-primary mr-1">de</span><span style="text-decoration: line-through;">R$ {{data.price | currency}}</span></p>
                              <span class="font-weight-bold font-size-13 text-primary mr-1">por</span><span class="badge badge-primary font-size-14">R$ {{data.quantityDiscount.price | currency}}</span>
                            </div>
                          </td>
                          <td class="justify-content-center">
                            <div class="btn-group mr-2 mb-2 mb-sm-0" v-if="data.available">
                              <button type="button" class="btn btn-outline-primary" @click="removeItem(data)">
                                <i class="fa fa-minus"></i>
                              </button>
                              <input
                                type="tel"
                                :id="data._id"
                                class="form-control input-quantity"
                                v-model="data.cartQuantity"
                                v-mask="'####'"
                              />
                              <button type="button" class="btn btn-outline-primary" @click="addItem(data)">
                                <i class="fa fa-plus"></i>
                              </button>
                            </div>

                            <!-- <div class="font-weight-bold font-size-16 text-center">R$ {{data.price}}</div> -->
                          </td>
                          <!-- <td class="font-weight-bold font-size-16 text-truncate">R$ {{data.price}}</td> -->
                          <td class="text-truncate">
                            <div v-if="data.available">
                              <button type="button" class="btn btn-primary btn-sm mr-3" :disabled="!data.available" @click="addToCart(data)">
                                <i class="mdi mdi-cart-plus font-size-18"></i>
                              </button>

                              <a href="javascript:void(0);" class="action-icon text-danger" @click="removeFromCart(data)">
                                <i class="mdi mdi-trash-can font-size-18"></i>
                              </a>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- end row-->
                </div>
              </div>

              <div class="row justify-content-md-between align-items-md-center mt-4">
                <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>
                <!-- end col-->
                <div class="col-xl-5">
                  <div class="text-md-right float-xl-right mt-2 pagination-rounded">
                    <b-pagination
                      v-model="currentPage" 
                      :total-rows="count"
                      :per-page="perPage"
                      @input="onPageChange"
                    ></b-pagination>
                  </div>
                </div>
                <!-- end col-->
              </div>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <vue-gallery-slideshow
      v-if="imageZoomIndex >= 0"
      :images="images"
      :index="imageZoomIndex"
      @close="imageZoomIndex = null"
    ></vue-gallery-slideshow>

    <b-modal
      id="modal-remove"
      title="Cancelar Orçamento?"
      title-class="font-18"
      centered
    >
      <p>Confirma o cancelamento do orçamento?</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-remove')" class="mr-2">Agora Não</b-btn>
        <b-btn variant="primary" @click="cancelOrder">Cancelar Orçamento</b-btn>
      </div>
    </b-modal>

    <b-modal
      id="modal-barcode"
      title="Leitura do Código de Barras"
      title-class="font-18"
      centered
    >
      <StreamBarcodeReader @decode="onDecode"></StreamBarcodeReader>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-barcode')" class="mr-2">Cancelar</b-btn>
      </div>
    </b-modal>

    <b-modal
      v-model="showTaxesModal"
      title="Informações de Impostos"
      centered
    >
      <div class="row">
        <div class="col-lg-12">
          <div class="table-responsive">
            <table class="table mb-0">
              <tbody>
                <tr>
                  <td>IVA/Carga Média</td>
                  <td>{{productSelected.taxes.stPercentage | currency}}%</td>
                </tr>
                <tr>
                  <td>Valor ST</td>
                  <td>R$ {{productSelected.taxes.stValue | currency}}</td>
                </tr>
                <tr>
                  <td>% IPI</td>
                  <td>{{productSelected.taxes.ipiPercentage | currency}}%</td>
                </tr>
                <tr>
                  <td>Valor IPI</td>
                  <td>R$ {{productSelected.taxes.ipiValue | currency}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="primary" @click="showTaxesModal = false">Fechar</b-button>
      </template>
    </b-modal>
  </Layout>
</template>

<style lang="scss">
  .search-input form {
    display: flex;
    flex-direction: row;

    .btn {
      margin-left: 10px;
    }
  }

  .btn-link {
    padding-left: 0px;
  }

  .input-quantity {
    max-width: 80px;
    min-width: 40px;
    border-radius: 0px;
    text-align: center;
  }

  .price-col {
    text-align: right;
  }

  tr.in-cart {
    background-color: #f0f8ff;;
  }

  img.gallery-image {
    cursor: pointer;
  }

  p.zoom-image-info {
    font-size: 10px;
    line-height: 12px;
  }

  .product-image {
    min-width: 100px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .empty-data {
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
  }

  // .table td {
  //   border-top: none;
  //   border-bottom: 1px solid #eff2f7;
  // }
</style>